<template>
  <div class="signup-risk">
    <div>
      <div class="bmcs-con">
        <div>
          <div class="title bmcs"></div>
          <div class="goods-name">即将开启，敬请期待</div>
          <!-- <div v-for="(item,index) in goodscount" :key="index">
            <div class="goods-name">参赛产品信息{{parseInt(productLength)+index+1}}</div>
            <div class="tables goods-tables">
              <div class="close" v-if="goodscount.length!=1" @click="reduceProducts(index)">X 删除此产品</div>
              <table style="text-align: left">
                <tr style="height: 45px;">
                  <th style="width: 330px;">* 参赛产品全称</th>
                  <td style="width: 585px;"><input v-model="item.productName" class="fullinput"
                                                               placeholder="(与备案名称相同)"/></td>
                </tr>
                <tr style="height: 45px;">
                  <th>* 参赛产品简称</th>
                  <td><input v-model="item.productShortName" class="fullinput"
                                         placeholder="(包括标点符号不超过10个字符)"
                                         maxlength="10"/></td>
                </tr>
                <tr style="height: 45px;">
                  <th>* 中基协备案编码</th>
                  <td><input v-model="item.productRecordNum" class="fullinput" style="height: 48px;"/></td>
                </tr>
                <tr style="height: 45px;">
                  <th>中基协备案证明</th>
                  <td>
                    <div class="files"><span class="filename" v-if="item.fileName">{{item.fileName}}</span><span
                      class="filename fileholder" v-if="!item.fileName">(上传jpg、png、pdf、bmp格式且小于1M的文件)</span>
                      <div class="inputbutton"><input type="file"
                                                      accept="image/jpg,image/png,image/bmp,application/pdf"
                                                      @change="getFile($event,index)"
                                                      ref="file"/>
                        <div class="filebutton upload"><img src="../assets/upload.png"/>上传</div>
                      </div>
                      <div class="filebutton delete" @click="deleteFile($event,index)"><img src="../assets/delete.png"/>删除
                      </div>
                    </div>
                  </td>
                </tr>
                <tr style="height: 160px;">
                  <th>* 产品类型</th>
                  <td>
                    <div class="producttypelevel"><input v-model="item.groupName" value="3" :name="'goodstype'+index"
                                                         :id="'goodstype2'+index" type="radio"/><label
                      :for="'goodstype2'+index">CTA及衍生品策略<span>（主要投资于商品及金融衍生品，且投资比例超60%）</span></label></div>
                    <div class="producttypelevel"><input v-model="item.groupName" value="1" :name="'goodstype'+index"
                                                         :id="'goodstype0'+index" type="radio"/><label
                      :for="'goodstype0'+index">股票策略<span>（主要投资于股票市场，且总头寸占比超60%）</span></label></div>
                    <div class="producttypelevel"><input v-model="item.groupName" :name="'goodstype'+index" value="2"
                                                         :id="'goodstype1'+index" type="radio"/><label
                      :for="'goodstype1'+index">对冲策略<span>（同时持有资产相关、规模相当的多空头寸策略，且总头寸占比超60%）</span></label></div>
                   <div class="producttypelevel"><input v-model="item.groupName" value="4" :name="'goodstype'+index"
                                                         :id="'goodstype3'+index" type="radio"/><label
                      :for="'goodstype3'+index">混合策略<span>（采用多种投资策略，且每种策略的投资比例不超过60%）</span></label></div>
                    <div class="producttypelevel"><input v-model="item.groupName" value="5" :name="'goodstype'+index"
                                                         :id="'goodstype4'+index" type="radio"/><label
                      :for="'goodstype4'+index">其他策略<span>（包括固收、日内等其他各种策略）</span></label></div>
                  </td>
                </tr>
                <tr style="height: 50px;">
                  <th>* 是否为程序化交易</th>
                  <td><input v-model="item.isProcedural" value="1" :name="'jy'+index" :id="'jy0'+index"
                                         type="radio"/><label :for="'jy0'+index">是</label><input
                    :name="'jy'+index"
                    v-model="item.isProcedural" :id="'jy1'+index"
                    value="0"
                    type="radio"/><label :for="'jy1'+index">否</label>
                  </td>
                </tr>
                <tr style="height: 50px;">
                  <th>* 成立日期</th>
                  <td><input class="cldate moreinput" @input="item.clyear=item.clyear.replace(/[^\d]/g,'')"
                                         v-model="item.clyear" placeholder="YYYY" maxlength="4"
                                         @keyup="nextFocus($event)"/> - <input
                    @input="item.clmonth=item.clmonth.replace(/[^\d]/g,'')" class="cldate lessinput"
                    v-model="item.clmonth" placeholder="MM" maxlength="2" @keyup="nextFocus($event)"/> - <input
                    class="cldate lessinput" v-model="item.clday" placeholder="DD" maxlength="2"
                    @input="item.clday=item.clday.replace(/[^\d]/g,'')" @keyup="nextFocus($event)"/>
                  </td>
                </tr>
                <tr style="height: 50px;">
                  <th>* 产品到期日</th>
                  <td><input class="moreinput" v-model="item.dqyear"
                                         @input="item.dqyear=item.dqyear.replace(/[^\d]/g,'')" placeholder="YYYY"
                                         maxlength="4"/> -
                    <input
                      class="lessinput" v-model="item.dqmonth" placeholder="MM" maxlength="2"
                      @input="item.dqmonth=item.dqmonth.replace(/[^\d]/g,'')"/> - <input
                      class="lessinput"
                      v-model="item.dqday"
                      placeholder="DD"
                      maxlength="2" @input="item.dqday=item.dqday.replace(/[^\d]/g,'')"/></td>
                </tr>
                <tr style="height: 50px;">
                  <th>* 产品净资产（参赛需1,000万元以上）</th>
                  <td><input v-model="item.productSize"
                                         @input="item.productSize=item.productSize.replace(/[^\d^\.]+/g,'')"
                                         class="fullinput jzc" style="height: 50px;"
                                         placeholder="(单位：万元)"/><span v-if="item.productSize">万元</span></td>
                </tr>
                <tr style="height: 43px;">
                  <th>* 净值填报方式
                  </th>
                  <td><input v-model="item.valuationSubmitType" value="1" :name="'fs'+index" :id="'fs0'+index"
                                               type="radio"/><label :for="'fs0'+index">登陆网站填报</label><input
                  :name="'fs'+index"
                  v-model="item.valuationSubmitType" :id="'fs1'+index"
                  value="2"
                  type="radio"/><label :for="'fs1'+index">CBS填报</label>
                </td>
                </tr>
              </table>
            </div>
            <div class="goods-line" v-if="goodscount.length>1"></div>
          </div>
          <div class="m-center">
            <div class="add-goods" @click="addgoodsCount">继续添加参赛产品</div>
            <div class="max-e">(同一机构最多 8 个产品参赛)</div>
            <div class="suresignup" @click="suresignup">确认报名</div>
          </div> -->
        </div>
      </div>
    </div>
    <noticeconfirm v-if="goOnNoticeMessage!=''" :goOnNoticeMessage="goOnNoticeMessage" @sureGoOn="sureGoOn"
                   @sureCancel="sureCancel"></noticeconfirm>

  </div>
</template>
<script>
  import {http} from '../fetch/api'
  import format from '../fetch/format'
  export default {
    data() {
      return {
        closenotice: true,
        institutName: "",
        institutRecordNum: "",
        institutRecordAttach: "",
        assetSize: "",
        institutLicenseAttach: "",
        linkman: "",
        linkmanMobile: "",
        linkmanPhone: "",
        linkmanEmail: "",
        linkmanQQ: "",
        hasread: "",
        goodscount: [{}],
        goOnNoticeMessage: "",
        productLength: 0
      }
    },
    mounted() {
      if(this.$store.state.loginState) {
        this.productLength = window.localStorage.productList ? window.localStorage.productList : 0
      } else {
        var temp=format.formatKeys(this.$route.query)
        var params=temp.substring(0,temp.length-1)
        this.$router.push("/?"+params)
        // this.$set(this.$store.state,'loginState',false)
        // this.$forceUpdate()
      }
    },
    methods: {
      sureGoOn() {
        this.goOnNoticeMessage = ""
        window.location.reload()
      },
      sureCancel() {
        this.goOnNoticeMessage = ""
        var temp=format.formatKeys(this.$route.query)
        var params = temp.substring(0, temp.length - 1)
        this.$router.push("/personal?" + params)

        // this.$router.push({"path":"personal"})
      },
      reduceProducts(index) {
        this.goodscount.splice(index, 1)
      },
      addgoodsCount() {
        if ((this.goodscount.length + parseInt(window.localStorage.productList)) < 8) {
          this.goodscount.push({})
        } else {
          // format.message('同一机构最多 8 个产品参赛', 'error')
          this.$store.state.noticeMessage = "您已添加 " + window.localStorage.productList + " 个产品，同一机构最多 8 个产品参赛"
        }
      },
      async getFile(event, index) {
        if (event.target.files[0].size > 1024000) {
          this.$store.state.noticeMessage = '请上传小于1M的文件'
          return
        } else {
          // this.goodscount[index].productRecordAttach = event.target.files
          this.$set(this.goodscount[index], "fileName", event.target.files[0].name)
          this.$forceUpdate()
          let formData = new FormData();
          formData.append('file', event.target.files[0], event.target.files[0].name);
          // formData.append('file', '123');
          var data = await http.upload(formData)
          if(data.code=='0') {
          this.$set(this.goodscount[index],'productRecordAttach',data.data.url)
          } else {
            this.$set(this.goodscount[index], "fileName", '')
            this.$set(this.goodscount[index],'productRecordAttach',"")
            this.$forceUpdate()
          }
        }
      },
      deleteFile(event, index) {
        this.goodscount[index].productRecordAttach = ""
        this.$set(this.goodscount[index], "fileName", "")
        this.$forceUpdate()
      },
      async suresignup() {
        for (var i = 0; i < this.goodscount.length; i++) {
          var j=i+1+parseInt(window.localStorage.productList)
          if (!this.goodscount[i].productName) {
            // format.message("请填写参赛产品" + (i + 1) + "产品全称", "error")
            this.$store.state.noticeMessage = "请填写参赛产品" + j+ "产品全称"
            return
          }
          if (!this.goodscount[i].productShortName) {
            // format.message("请填写参赛产品" + (i + 1) + "产品简称", "error")
            this.$store.state.noticeMessage = "请填写参赛产品" + j + "产品简称"
            return
          }
          if (!this.goodscount[i].productRecordNum) {
            // format.message("请填写参赛产品" + (i + 1) + "中基协备案编码", "error")
            this.$store.state.noticeMessage = "请填写参赛产品" + j + "中基协备案编码"
            return
          }
          // if (!this.goodscount[i].productRecordAttach) {
          // format.message("请上传参赛产品" + (i + 1) + "中基协备案证明", "error")
          // this.$store.state.noticeMessage="请上传参赛产品" + (i + 1) + "中基协备案证明"
          // return
          // }

          if (!this.goodscount[i].groupName) {
            // format.message("请选择参赛产品" + (i + 1) + "产品类型", "error")
            this.$store.state.noticeMessage = "请选择参赛产品" + j + "产品类型"
            return
          }
          if (!this.goodscount[i].isProcedural) {
            // format.message("请选择参赛产品" + (i + 1) + "是否为程序化交易", "error")
            this.$store.state.noticeMessage = "请选择参赛产品" + j + "是否为程序化交易"
            return
          }
          if (!this.goodscount[i].clyear) {
            // format.message("请选择参赛产品" + (i + 1) + "成立日期", "error")
            this.$store.state.noticeMessage = "请填写参赛产品" + j + "成立日期"
            return
          }
          if (!this.goodscount[i].clmonth) {
            // format.message("请选择参赛产品" + (i + 1) + "成立日期", "error")
            this.$store.state.noticeMessage = "请填写参赛产品" + j + "成立日期"
            return
          } else if (this.goodscount[i].clmonth > 12) {
            this.$store.state.noticeMessage = "请填写参赛产品" + j + "合法的成立日期"
            return
          }
          if (!this.goodscount[i].clday) {
            // format.message("请填写参赛产品" + (i + 1) + "成立日期", "error")
            this.$store.state.noticeMessage = "请填写参赛产品" + j + "成立日期"
            return
          } else if (this.goodscount[i].clday > 31) {

            this.$store.state.noticeMessage = "请填写参赛产品" + j + "合法的成立日期"
            return
          }
          if (!this.goodscount[i].dqyear) {
            // format.message("请填写参赛产品" + (i + 1) + "到期日", "error")
            this.$store.state.noticeMessage = "请填写参赛产品" + j + "产品到期日"
            return
          }
          if (!this.goodscount[i].dqmonth) {
            // format.message("请填写参赛产品" + (i + 1) + "到期日", "error")
            this.$store.state.noticeMessage = "请填写参赛产品" + j + "产品到期日"
            return
          } else if (this.goodscount[i].dqmonth > 12) {
            this.$store.state.noticeMessage = "请填写参赛产品" + j + "合法的产品到期日"
            return
          }
          if (!this.goodscount[i].dqday) {
            // format.message("请填写参赛产品" + (i + 1) + "到期日", "error")
            this.$store.state.noticeMessage = "请填写参赛产品" + j + "产品到期日"
            return
          } else if (this.goodscount[i].dqday > 31) {

            this.$store.state.noticeMessage = "请填写参赛产品" + j + "合法的产品到期日"
            return
          }
          if (!this.goodscount[i].productSize) {
            // format.message("请填写参赛产品" + (i + 1) + "产品净资产", "error")
            this.$store.state.noticeMessage = "请填写参赛产品" + j + "产品净资产"
            return
          } else if (this.goodscount[i].productSize < 1000) {
            this.$store.state.noticeMessage = "参赛产品" + j + "产品净资产须大于1000万"
            return
          }
          if (!this.goodscount[i].valuationSubmitType) {
            // format.message("请选择参赛产品" + (i + 1) + "净值填报方式", "error")
            this.$store.state.noticeMessage = "请选择参赛产品" + j + "净值填报方式"
            return
          }
          // if (!this.goodscount[i].submitEmail && this.goodscount[i].valuationSubmitType == '2') {
          //   // format.message("请填写参赛产品" + (i + 1) + "填报邮箱", "error")
          //   this.$store.state.noticeMessage = "请填写参赛产品" + (i + 1) + "填报邮箱"
          //   return
          // }
          this.goodscount[i].productBeginDate = this.goodscount[i].clyear + "-" + this.goodscount[i].clmonth + "-" + this.goodscount[i].clday
          this.goodscount[i].productEndDate = this.goodscount[i].dqyear + "-" + this.goodscount[i].dqmonth + "-" + this.goodscount[i].dqday
        }
        var data = await http.productList(this.goodscount)
        if (data.code == "0") {
          window.localStorage.productList = parseInt(window.localStorage.productList) + this.goodscount.length

          // format.message("添加产品成功")
          this.goOnNoticeMessage = "添加产品成功,是否继续添加产品？"
        }
      },
      nextFocus(el) {
        // var dom = document.getElementsByClassName("cldate")
        // currInput = dom[index],
        // nextInput = dom[index + 1],
        // lastInput = dom[index - 1];
        /*这里的keyCode 根据不同的平台或许不同,安卓就是不是8*/
        // if (el.keyCode != 8) {
        //   if (index < (this.inputList.length - 1)) {
        //     nextInput.focus();
        //   } else {
        //     currInput.blur();
        //   }
        // }else{
        //   if (index !=0) {
        //     lastInput.focus();
        //   }
        // }

      },
      notClose(event) {
        event.stopPropagation()
      }
    }
  }
</script>
<style scoped>
  .smglrxx, .cscpxx {
    height: 60px;
    line-height: 60px;
    background: #f4f7f9;
  }

  .smglrxx div, .cscpxx div {
    width: 1200px;
    margin: 0 auto;
    font-size: 16px;
  }

  .title {
    height: 67px;
    line-height: 67px;
    text-align: center;
    font-size: 30px;
    letter-spacing: 5px;
    margin: 0 auto 35px auto;
    background-repeat: no-repeat;
    background-size: 750px;
    background-position: center;
  }

  .title span {
    padding-left: 50px;
    display: inline-block;
    background-image: -webkit-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -o-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -moz-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: linear-gradient(73deg, #0c3b95, #cf5860);
    -webkit-background-clip: text;
    -ms-background-clip: text;
    -o-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    -o-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
    text-fill-color: transparent;
    font-weight: bold;

  }

  .bmcs-con > div {
    padding: 50px 0;
    width: 1200px;
    margin: 0 auto;
  }

  .bmcs {
    background-image: url("../assets/bmcs.png");
  }

  .goods-name {
    text-align: center;
    font-family: MicrosoftYaHei-Bold;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 32px;
    letter-spacing: 1px;
    color: #007fcf;
  }

  .tables {
    margin: 20px auto 0 auto;
    padding: 6px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
  }

  .producttypelevel {
    line-height: 32px;
  }

  .producttypelevel span {
    color: #cacaca;
  }

  .close {
    position: absolute;
    right: 10px;
    top: -20px;
    color: #0ff;
  }

  .manager-tables {
    width: 880px;
    height: 530px;
    background-image: url("../assets/smglr.png");
  }

  .manager-tables td input {
    width: 580px;
    padding: 0 10px;
    box-sizing: border-box;
    margin: 0;
    border: none;
    height: 52px;
    background: none;
    outline: none;

  }

  .goods-tables {
    width: 977px;
    height: 647px;
    background-image: url("../assets/cscpxx.png");
  }

  table input {
    margin: 0 5px 0 10px;
  }

  table th {
    padding: 0 20px;
    box-sizing: border-box;
  }

  .m-center {
    margin: 30px auto;
    text-align: center;
  }

  .add-goods {
    color: #27a7ea;
    text-decoration: underline;
    cursor: pointer;
    height: 30px;
    line-height: 30px;
    display: inline-block;
  }

  .max-e {
    color: #b5b5b5;
    text-decoration: none;
    height: 30px;
    line-height: 30px;
  }

  .suresignup {
    width: 400px;
    border-radius: 6px;
    height: 50px;
    line-height: 50px;
    background: #27a7ea;
    color: #fff;
    margin: 20px auto;
  }

  .risknotice {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 99;
  }

  .notice-content {
    background-repeat: no-repeat;
    background-size: contain;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-image: url("../assets/fxgz.png");
    width: 1020px;
    height: 735px;
  }

  .notice-title {
    text-align: center;
    font-family: MicrosoftYaHei;
    font-size: 22px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 28px;
    height: 28px;
    letter-spacing: 1px;
    margin: 10px 0;
    color: #27a7ea;
  }

  .whitediv {
    height: 60px;
  }

  .noticetext {

    font-size: 16px;
    margin: 0px 70px 30px 70px;
    text-align: left;
    height: 550px;
    overflow: scroll;
  }

  .noticetext p {
    line-height: 28px;
    letter-spacing: 1px;
  }

  /*滚动条整体样式*/
  .noticetext::-webkit-scrollbar {
    width: 8px;
    height: 1px;
  }

  /*滚动条滑块*/
  .noticetext::-webkit-scrollbar-thumb {
    border-radius: 0px;
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.1);
    background: #a4f1fc;
  }

  /*滚动条轨道*/
  .noticetext::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    border-radius: 10px;
    background: none;
  }

  .agree {
    text-align: center;
    width: 240px;
    background: #00bcbc;
    margin: 0 auto;
    color: #fff;
    height: 50px;
    line-height: 50px;
    border-radius: 6px;
  }

  .table {
    width: 500px;
    margin: 20px auto;
    text-align: center;
    border-left: solid 1px #232323;
    border-top: solid 1px #232323;
  }

  .table th, .table td {
    border-right: solid 1px #232323;
    border-bottom: solid 1px #232323;
  }

  .closebutton {
    position: absolute;
    color: #fff;
    right: 20px;
    top: -25px;
  }

  .nextstep-con {
    text-align: center;
    margin-top: 30px;
  }

  .agreerisk {
    color: #27a7ea;
  }

  .agreerisk a {
    text-decoration: underline;
  }

  .stepbutton {
    width: 400px;
    height: 50px;
    line-height: 50px;
    margin: 0 auto;
    background: #b5b5b5;
    border-radius: 6px;
    margin-top: 30px;
    color: #fff;
  }

  .goods-tables .fullinput {
    width: 610px;
    height: 51px;
    outline: none;
    background: none;
    border: none;
    padding: 0 10px;
    margin: 0;
    box-sizing: border-box;
  }

  .goods-tables .jzc {
    width: 130px;
  }

  .goods-tables .moreinput, .goods-tables .lessinput {
    height: 48px;
    outline: none;
    background: none;
    border: none;
    padding: 0 10px;
    margin: 0;
    box-sizing: border-box;
  }

  .goods-tables .moreinput {
    width: 65px;
  }

  .goods-tables .lessinput {
    width: 50px;
  }

  .emailinput {
    width: 290px;
    height: 50px;
    margin: 0;
    padding: 0 10px;
    border: none;
    box-sizing: border-box;
    outline: none;

  }

  .files {
    position: relative;
  }

  .inputbutton {
    position: absolute;
    display: inline-block;
    width: 90px;
    height: 48px;
    line-height: 48px;
    right: 110px;
  }

  .filename {
    width: 380px;
    height: 40px;
    line-height: 40px;
    border: none;
    outline: none;
    display: inline-block;
    padding-left: 10px;
  }

  .fileholder {
    color: #cacaca;
    font-size: 16px;
  }

  input::-webkit-input-placeholder {
    color: #cacaca;
    font-size: 16px;
  }

  input::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #cacaca;
    font-size: 16px;
  }

  input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #cacaca;
    font-size: 16px;
  }

  input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #cacaca;
    font-size: 16px;
  }

  input[type='file'] {
    opacity: 0;
    width: 90px;
    height: 40px;
    position: absolute;
    right: 0;
    top: 0;
    margin: 0;
  }

  .filebutton {
    display: inline-block;
    width: 90px;
    border: solid 1px;
    text-align: center;
    border-radius: 6px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;

  }

  .filebutton img {
    width: 22px;
    margin-right: 10px;
    vertical-align: middle;
  }

  .upload {
    pointer-events: none;
    border-color: #007fcf;
    color: #007fcf;
    position: absolute;
    right: 0;
    top: -1px;
  }

  .delete {
    border-color: #f53f3f;
    color: #f53f3f;
    position: absolute;
    right: 10px;
    top: -1px;
  }

  .goods-line {
    background-image: url("../assets/goodsline.png");
    background-repeat: no-repeat;
    height: 16px;
    background-size: contain;
    margin: 20px auto;
    width: 977px;
  }
</style>



// WEBPACK FOOTER //
// src/components/signup.vue